import request from "@/utils/request";

// 登录方法
export default function () {
  return request({
    url: "/system/company/queryCompanyByUser",
    method: "GET",
  });
}
